import { useState, useEffect } from "react"
import { Box, Button, Chip, Typography } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import MainLayout from "../components/layout/Main"
import api from "../api"

function Users() {
  const [usersData, setUsersData] = useState([])
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()
  const { t } = useTranslation()

  const columns = [
    { 
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    { 
      field: 'username',
      headerName: t("users.username_column"),
      width: 150,
      flex: 1,
    },
    { 
      field: 'email',
      headerName: t("users.email_column") || "Email",
      width: 200,
      flex: 1,
    },
    { 
      field: 'first_name',
      headerName: t("users.first_name_column") || "First Name",
      width: 150,
      flex: 1,
    },
    { 
      field: 'last_name',
      headerName: t("users.last_name_column") || "Last Name",
      width: 150,
      flex: 1,
    },
    { 
      field: 'is_superuser',
      headerName: t("users.superuser_column") || "Superuser",
      width: 120,
      renderCell: (params) => (
        params.value ? (
          <Chip label="Yes" color="primary" size="small" />
        ) : (
          <Chip label="No" size="small" />
        )
      ),
    },
    { 
      field: 'is_staff',
      headerName: t("users.staff_column") || "Staff",
      width: 100,
      renderCell: (params) => (
        params.value ? (
          <Chip label="Yes" color="info" size="small" />
        ) : (
          <Chip label="No" size="small" />
        )
      ),
    },
    { 
      field: 'is_active',
      headerName: t("users.active_column") || "Active",
      width: 100,
      renderCell: (params) => (
        params.value ? (
          <Chip label="Active" color="success" size="small" />
        ) : (
          <Chip label="Inactive" color="error" size="small" />
        )
      ),
    },
    { 
      field: 'date_joined',
      headerName: t("users.joined_column") || "Date Joined",
      width: 180,
      valueFormatter: (params) => {
        if (!params) return '';
        return new Date(params).toLocaleString();
      },
    },
    { 
      field: 'last_login',
      headerName: t("users.last_login_column") || "Last Login",
      width: 180,
      valueFormatter: (params) => {
        if (!params) return 'Never';
        return new Date(params).toLocaleString();
      },
    },
  ]

  useEffect(() => {
    getUserList()
    document.title = t("users.page_title")
  }, [])

  const getUserList = () => {
    setLoading(true)
    api
      .get("/api/user/list/")
      .then((res) => res.data)
      .then((data) => {
        setUsersData(data)
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
  }

  return (
    <MainLayout activeComponent='/users'>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 3 }}>
          <Typography variant="h5" component="h1">
            {t("users.page_title") || "User Management"}
          </Typography>
          <Button variant="contained" onClick={() => navigate("/users/add")} >
            {t("users.add_user_button")}
          </Button>
        </Box>
        
        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid 
            rows={usersData}
            columns={columns}
            loading={loading}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 25, 50]}
            disableSelectionOnClick
            sx={{
              '& .MuiDataGrid-cell': {
                display: 'flex',
                alignItems: 'center',
              },
            }}
          />
        </Box>
      </Box>
    </MainLayout>
  )
}

export default Users